export default __webpack_public_path__ + "static/media/golive-2026.caf2ad54.png";